import { render, staticRenderFns } from "./IntegratorCaseStudyScreen.vue?vue&type=template&id=27c5e8a0"
import script from "./IntegratorCaseStudyScreen.vue?vue&type=script&lang=js"
export * from "./IntegratorCaseStudyScreen.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports